import React from 'react';
import { Chip } from '@mui/material';

export type Tone = 'ok' | 'warn' | 'danger' | 'neutral' | 'info';

// Status pills, drawn the way the vault draws them: the palette's `light`
// as the ground and `dark` as the text, so the pill carries its meaning at
// a glance without shouting. Operations used to hand-roll this as a Box
// with `bgcolor: hex + '22'` and solid-colour text, which put a second,
// lower-contrast pill style in the product for exactly the same job.

const toneToPalette: Record<Tone, 'success' | 'warning' | 'error' | 'default' | 'info'> = {
  ok: 'success',
  warn: 'warning',
  danger: 'error',
  neutral: 'default',
  info: 'info',
};

const ToneChip: React.FC<{
  tone: Tone;
  label: React.ReactNode;
  size?: 'small' | 'medium';
  /** Outline instead of fill — for an absence rather than a state. */
  hollow?: boolean;
}> = ({ tone, label, size = 'small', hollow }) => {
  const palette = toneToPalette[tone];
  return (
    <Chip
      size={size}
      label={label}
      variant={hollow ? 'outlined' : 'filled'}
      color={palette}
      sx={{
        fontWeight: 700,
        fontSize: 12,
        textTransform: 'capitalize',
        ...(hollow || palette === 'default'
          ? {}
          : { bgcolor: `${palette}.light`, color: `${palette}.dark` }),
      }}
    />
  );
};

export default ToneChip;
